import PropTypes from 'prop-types';
import { Box, Dialog, Grow, Typography } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import Iconify from 'src/components/Iconify';
import FollowUpWhatsappChat from 'src/components/whatsappComponents/FollowUpWhatsappChat';

export default function IosWhatsAppComposerDialog({
    open,
    onClose,
    leadId,
    practiceId,
    phoneNumber,
    leadDetail,
    onSendSuccess,
    windowExpired,
    prefillWaTemplateId,
    prefillWaTemplateName,
    prefillWaItemId,
}) {
    const isMobile = useMediaQuery('(max-width:600px)');

    // Build the user object FollowUpWhatsappChat expects
    // Null-guard: ensure lead_contact.phone is always a string to prevent FollowUpWhatsappChat crash
    const userProp = leadDetail
        ? { ...leadDetail, lead_contact: { ...(leadDetail.lead_contact || {}), phone: leadDetail?.lead_contact?.phone || '' } }
        : { id: leadId, lead_contact: { phone: phoneNumber || '' } };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Grow}
            TransitionProps={{ timeout: 180 }}
            fullWidth
            fullScreen={isMobile}
            maxWidth="lg"
            BackdropProps={{
                sx: {
                    backdropFilter: 'blur(4px)',
                    backgroundColor: 'rgba(0,0,0,0.32)',
                },
            }}
            PaperProps={{
                sx: {
                    borderRadius: isMobile ? 0 : '16px',
                    maxHeight: '90vh',
                    height: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: 24,
                    overflow: 'hidden',
                },
            }}
        >
            {windowExpired && (
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 2,
                    py: 1,
                    bgcolor: 'warning.lighter',
                    borderBottom: '1px solid',
                    borderColor: 'warning.light',
                    flexShrink: 0,
                }}>
                    <Iconify icon="eva:alert-triangle-outline" width={16} sx={{ color: 'warning.dark', flexShrink: 0 }} />
                    <Typography variant="caption" sx={{ color: 'warning.dark', fontWeight: 500 }}>
                        24-hour window expired — only WhatsApp templates can be sent
                    </Typography>
                </Box>
            )}
            <FollowUpWhatsappChat
                user={userProp}
                onMessageSent={onSendSuccess}
                prefillWaTemplateId={prefillWaTemplateId}
                prefillWaTemplateName={prefillWaTemplateName}
                prefillWaItemId={prefillWaItemId}
            />
        </Dialog>
    );
}

IosWhatsAppComposerDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    leadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    practiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    phoneNumber: PropTypes.string,
    leadDetail: PropTypes.object,
    onSendSuccess: PropTypes.func,
    windowExpired: PropTypes.bool,
    // Mapped WhatsApp template resolved from a checklist mapping — id (matched
    // first) + name (fallback). When set, ChatPage previews + sends it via the
    // approved-template path.
    prefillWaTemplateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    prefillWaTemplateName: PropTypes.string,
    // The checklist/task item id — scopes the mapped-draft dismissed flag.
    prefillWaItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IosWhatsAppComposerDialog.defaultProps = {
    leadId: null,
    practiceId: null,
    phoneNumber: '',
    leadDetail: null,
    onSendSuccess: null,
    windowExpired: false,
    prefillWaTemplateId: null,
    prefillWaTemplateName: null,
    prefillWaItemId: null,
};
